import { chargeCodeConfigurationObject, chargeCodeTableObject } from "../interfaces";

// Groups the invoice charge codes by charge type, one table row per charge type.
export function getChargeCodeListFromMapping(chargeCodeConfigurationList: chargeCodeConfigurationObject[]) {
    let chargeTypeToInvoiceCodes: Map<string, string[]> = new Map<string, string[]>();
    chargeCodeConfigurationList.forEach(chargeCodeConfiguration => {
        let chargeType: string = chargeCodeConfiguration.chargeType;
        chargeTypeToInvoiceCodes.set(chargeType,
            [...(chargeTypeToInvoiceCodes.get(chargeType) || []), chargeCodeConfiguration.invoiceChargeCode]);
    });

    let tableData: chargeCodeTableObject[] = [];
    chargeTypeToInvoiceCodes.forEach((invoiceChargeCodes: string[], chargeType: string) => {
        tableData.push({
            chargeType: chargeType,
            invoiceChargeCodes: invoiceChargeCodes
        });
    });
    return tableData;
}
